import { writable } from "svelte/store";
import { auth } from "../services/auth.js";
import { config } from "../config.js";
import { del, get, post } from "../services/http.js";

function createUser() {
  const load = async () => {
    let u = await auth.getAuthenticatedUser();
    if (u && u.user) {
      set({ username: u.user, subscriptionDetails: null });
    } else {
      set({ username: null, subscriptionDetails: null });
    }
  };

  const { subscribe, set, update } = writable(
    load() || { username: null, subscriptionDetails: null }
  );

  return {
    subscribe,
    logout: () => {
      update((user) => {
        return { username: null };
      });
      auth.logout();
    },
    login: async () => {
      let u = await auth.getIdToken();
      update((user) => {
        if (u && u.user) {
          user.username = u.user;
        }
        return user;
      });
    },
    getUsername: () => {
      return auth.getAuthenticatedUser();
    },
    updateSubStatus: async (isSub) => {
      if (!isSub) {
        await del(`${config.apiUrl}/email/subscriber`, JSON.stringify({}));
      } else {
        await post(`${config.apiUrl}/email/subscriber`, JSON.stringify({}));
      }
    },

    // this is a temporary fix to show the user how many shipments they
    // have available after they renew before the payment fully finishes
    setRenewEarlyData: () => {
      update((user) => {
        user.subscriptionDetails.shipments_available =
          user.subscriptionDetails.shipments_per_cycle;
        return user;
      });
    },
    checkSubscription: async () => {
      if (auth.getAuthenticatedUser()) {
        let url = `${config.apiUrl}/account/subscription`;
        let result = await get(url);
        if (result && !result.error) {
          update((user) => {
            user.subscriptionDetails = result;
            return user;
          });
        }
        return result;
      }

      return null;
    },
  };
}

export let user = createUser();
